// extracted by mini-css-extract-plugin
export default {"tile":"tile-module___tile___e940bd90","light":"tile-module___light___f623b2e9"};